<template>
    <section class="cost-container">
        <div class="cost-breakdown">
            <div class="cost-type fs-12">کرایه</div>
            <div class="divider"></div>
            <div class="cost-label">
                <span class="fw-bolder fs-12" v-if="cargo.priceBased == 'به ازای هر تن'">
                    به ازای هر تن: {{ formatPrice(cargo.suggestedPrice) }}
                </span>
                
                <span class="fw-bolder fs-12"
                    v-if="cargo.priceBased == 'به صورت صافی' || cargo.priceBased == 'بصورت صافی'">
                    بصورت صافی
                </span>
            </div>
        </div>
        <div class="total-cost">
            <span class="fw-bolder fs-12" v-if="cargo.priceBased == 'توافقی'">توافقی</span>
            <span class="fw-bolder fs-12" v-else>{{ formatPrice(cargo.suggestedPrice) }} تومان</span>
        </div>
    </section>
</template>
<script>
export default {
    props: ["cargo"],
    methods: {
        formatPrice(value) {
            let val = (value / 1).toFixed(0).replace(",", ",");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }


}
</script>
<style scoped>
.fs-12{
    font-size: 12px;
}
.cost-container {
    justify-content: space-between;
    border-radius: 8px;
    border: 1px solid rgba(217, 217, 217, 1);
    align-self: center;
    display: flex;
    margin-top: 16px;
    width: 100%;
    gap: 20px;
    text-align: center;
    padding: 0px 10px;
}

.total-cost {
    color: var(--Black, #000);
    margin: auto 0;
}

.cost-breakdown {
    justify-content: center;
    align-items: center;
    display: flex;
    gap: 8px;
}

.cost-label {
    color: var(--Gray-Text, #4d4d4d);
    font: 400 12px IRANSansXFaNum, sans-serif;
}

.divider {
    background-color: var(--Light-Gray, #d9d9d9);
    width: 1px;
    height: 38px;
}

.cost-type {
    color: var(--Black, #000);
    margin: auto 0;
    font: 500 14px IRANSansX, sans-serif;
}
</style>